// @ts-nocheck

import { colors } from '@lmc/common/constants'
import { Spinner as UiKitSpinner } from '@lmc/ui-kit'
import React, { Component } from 'react'

class Spinner extends Component<any, any> {
  render() {
    return (
      <div
        className={this.props.className}
        style={{ ...styles.container, ...this.props.style }}
        data-cy="loading-spinner"
        data-testid="loading-spinner"
      >
        <UiKitSpinner size="default" />
      </div>
    )
  }
}

const styles = {
  container: {
    width: '100%',
    textAlign: 'center',
    paddingTop: 100,
    color: colors.darkgrey
  }
}

export default Spinner
